import Layout from "../../components/layout";
import {GetStaticProps} from "next";
import LeadingCompany from "../../components/v2/leading-company-cta";
import Card from "../../components/v2/cards/card";
import TestimonialsDemoPage from "../../components/v2/mw-carousel/testimonial-demo-page";
import CalendlyWidget from "../../components/v2/calendly-demo";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import "../../styles/scss/contact-us.module.scss";

const KubconDemo = () => {
    return (
        <>
            <Layout
                isHomePage={false}
                pageTitle={"Request a Demo | Middleware at KubeCon"}
                ogImage={"/images/demo-request-thumbnail.png"}
                uri={"/demo-request/kubecon/"}
                metaTitle={"Request a Demo | Middleware at KubeCon"}
                metaDesc={
                    "Request a demo of Middleware's cloud observability platform at KubeCon to optimize infrastructure and enhance user experience."
                }
                metaRobotsNoindex={"index"}
                metaRobotsNofollow={"follow"}
            >
                <div className="middle-wrapper contact-us book-demo-page">
                    <div className={"container"}>
                        <div className={"contact"}>
                            <div className={"d-flex"}>
                                <div className={"left-block"}>
                                    <h1>
                                        Meet Us At{" "}
                                        <span className={"text-gradient"}> KubeCon NA USA 2024! </span>
                                    </h1>
                                    <p>Curious how Middleware can help you? Pre-register for an exclusive, personalized demo with our founders and leadership team, and upon signing up, enjoy a 14-day free trial with unlimited data ingestion across all platform features!</p>
                                    <LeadingCompany />

                                    <TestimonialsDemoPage />
                                </div>

                                <div className={"right-block"}>
                                    <CalendlyWidget />
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className={"mw-card"}>
                        <div className={"container"}>
                            <div className={"section-tag testimonial pd-right"}>
                                Middleware Impact 🚀
                            </div>
                            <h2>
                                Efficiency,{" "}
                                <span className={"text-gradient"}> Performance</span> and
                                Sustainability
                            </h2>
                            <div className={"d-flex card-items"}>
                                <Card
                                    title={"20%"}
                                    heading={"Faster Time To Resolution"}
                                    description={
                                        "Reduce MTTR with continuous monitoring and real-time insights into telemetry data."
                                    }
                                    isHeading={true}
                                />
                                <Card
                                    title={"100%"}
                                    heading={"Data Control"}
                                    description={
                                        "Control data ingestion with feature flags & filters for streamlined, cost-efficient insights."
                                    }
                                    isHeading={true}
                                />
                                <Card
                                    title={"25%"}
                                    heading={"Improved Dev Productivity"}
                                    description={
                                        "With real-time monitoring and automated workflows, your devs can focus on what matters."
                                    }
                                    isHeading={true}
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </Layout>
        </>
    );
};
export const getStaticProps: GetStaticProps = async (ctx) => {
    const translations = await serverSideTranslations(
        ctx?.locale ?? "en",
        ["common", "header", "footer"],
        nextI18NextConfig,
    );
    return {
        props: {
            ...translations,
            pageData: "",
            pageTitle: "Request a Demo | Middleware at KubeCon",
            description: "Request a demo of Middleware's cloud observability platform at KubeCon to optimize infrastructure and enhance user experience.",
            uri: "/demo-request/kubecon/",
            ogImage: "/images/demo-request-thumbnail.png",
            metaTitle: "Request a Demo | Middleware at KubeCon",
            metaDesc: "Request a demo of Middleware's cloud observability platform at KubeCon to optimize infrastructure and enhance user experience.",
            metaRobotsNoindex: "index",
            metaRobotsNofollow: "follow",
        },
    };
};

export default KubconDemo;

